// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__3SbQc","icon":"Backdrop_icon__3CfmQ"};